export const ACCESS_TOKEN = 'accessToken';
export const LANGUAGE = 'lang';
export const STRING_LENGTH = 255;
export const DATE_MAX = '2119-01-01';
export const DATE_MIN = '1900-01-01';
export const USE_ACTIVE_DIRECTORY = true;


